<template>
  <div>
    <titleBar :title="title" :param="$route.query" />
    <div class="innerCon couponLoading">
      <div class="money-top clearfix">
        <h3 class="money-h3">
          <span class="money-ttit">{{ $t('可用券额') }}</span>
        </h3>
        <div class="money-numw fl top-front-wrap">
          <div class="money-num">
            <strong class="money-strong">{{quota | formatMoney}}</strong>
            {{ $t('元') }}
          </div>
        </div>
        <div class="top-behind-wrap">
          <dl class="cash-expw-dl">
            <dt>{{ $t('提示') }}</dt>
            <dd>1.{{ $t('券额是指可以用于发放代金券的额度，券额的有效期为自发放之日起1年，逾期作废。') }}</dd>
            <dd>{{ $t('2_如果已经发放的代金券禁用之后会将剩余金额自动返还到券额里_') }}</dd>
          </dl>
        </div>
      </div>
      <div class="item-tab">
        <jc-tabs
          v-model="recordType"
          :active-name="recordType"
          type="border-card"
          style="background: #ebf1f5;"
        >
          <jc-tab-pane :label="$t('额度记录')" name="quotaRecord">
            <quota-record v-if="recordType === 'quotaRecord'"></quota-record>
          </jc-tab-pane>
          <jc-tab-pane :label="$t('发放记录')" name="grantRecord" style="background: #ebf1f5;">
            <issue-record v-if="recordType === 'grantRecord'"></issue-record>
          </jc-tab-pane>
        </jc-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import getTranslation from '@/i18n/getTranslation'
import titleBar from '@/components/titleBar'
import IssueRecord from './model/IssueRecord.vue'
import QuotaRecord from './model/QuotaRecord.vue'
import { quotaValue } from '@/api/coupon-api.js'
import quotaPermissionMixin from '@/mixins/quotaPermission-mixin.js'

export default {
  name: 'quotaCouponManage',
  mixins: [quotaPermissionMixin],
  data() {
    return {
      title: getTranslation('券额管理'),
      recordType: 'quotaRecord',
      quota: 0
    }
  },
  components: {
    titleBar,
    QuotaRecord,
    IssueRecord
  },
  methods: {
    async quotaValue() {
      try {
        let {
          body: {
            result: { data }
          }
        } = await quotaValue()
        this.quota = data || 0
      } catch (e) {
        this.quota = 0
      }
    }
  },
  created() {
    this.quotaValue()
  }
}
</script>
